<template>
    <div id="app">
        <div class="main-header">
            <img class="pl-4 pr-4 center-h" src="@/assets/icons/rocla.svg" height="10" width="43" />
            <div class="mode-links-position">
                <div v-if="licenseGenerationAllowed"
                    @click="$router.push('/')"
                    class="mode-links"
                    :class="currentRoute === '/' ? 'mode-links-selected' : ''">
                    <a class="pl-4 pr-4">Licenses</a>
                </div>
                <div v-if="stationAdjustmentAllowed"
                    @click="$router.push('/bulk_adjustment')"
                    class="mode-links"
                    :class="currentRoute === '/bulk_adjustment' ? 'mode-links-selected' : ''">
                    <a class="pl-4 pr-4">Bulk Adjustment</a>
                </div>
                <div v-if="versionGuardAllowed"
                    @click="$router.push('/version_guard')"
                    class="mode-links"
                    :class="currentRoute === '/version_guard' ? 'mode-links-selected' : ''">
                    <a class="pl-4 pr-4">Version Guard</a>
                </div>
                <div v-if="licenseListAllowed"
                    @click="$router.push('/license_list')"
                    class="mode-links"
                    :class="currentRoute === '/license_list' ? 'mode-links-selected' : ''">
                    <a class="pl-4 pr-4">License List</a>
                </div>
            </div>
            <div class="pl-4 user-info-area main-header">
                <user-menu class="center-h user-info-area" />
            </div>
        </div>
        <router-view v-if="loggedIn && (licenseGenerationAllowed || stationAdjustmentAllowed || versionGuardAllowed || licenseListAllowed)"/>
        <div v-else class="p-4">
            <el-link v-if="!loggedIn" type='primary' href='Session/SignIn'>Sign in</el-link>
            <span v-else>License generation has not been enabled for your account. Please contact site administrators.</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.main-header {
    display: flex;
}

.mode-links-position {
    display: flex;
    flex: 1 0;
    justify-content: center;
}

.center-h {
    align-self: center;
}

</style>

<script lang='ts'>
import { QueryUser } from '@/store';
import UserMenu from '@/components/UserMenu.vue';
import { ElMessage } from 'element-plus';
import { trackError } from '@/util/telemetry';

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'main-app',
    mounted() {
        this.queryUser();
    },
    methods: {
        async queryUser() {
            await this.$store.dispatch(new QueryUser(null));
            // If license generation isn't allowed, go to another tab.
            if (this.loggedIn
                && this.stationAdjustmentAllowed
                && !this.licenseGenerationAllowed) {
                this.$router.push('/bulk_adjustment');
            } else if (this.loggedIn
                && !this.licenseGenerationAllowed
                && !this.stationAdjustmentAllowed
                && this.versionGuardAllowed
            ) {
                this.$router.push('/version_guard');
            } else if (this.loggedIn
                && !this.licenseGenerationAllowed
                && !this.stationAdjustmentAllowed
                && !this.versionGuardAllowed
                && this.licenseListAllowed) {
                    this.$router.push('/license_list');
                }
        },
    },
    computed: {
        currentRoute(): string {
            return this.$route?.path ?? '/';
        },
        loggedIn(): boolean {
            return this.$store.state.user.loggedIn;
        },
        stationAdjustmentAllowed(): boolean {
            return this.$store.state.user.stationAdjustmentAllowed;
        },
        licenseGenerationAllowed(): boolean {
            return this.$store.state.user.licenseGenerationAllowed;
        },
        versionGuardAllowed(): boolean {
            return this.$store.state.user.versionGuardAllowed;
        },
        licenseListAllowed(): boolean {
            return this.$store.state.user.licenseListAllowed;
        },
    },
    components: { UserMenu },
    watch: {
        loggedIn(loggedInNew: boolean, loggedInOld: boolean) {
            if (loggedInOld && !loggedInNew) {
                ElMessage({
                    message: 'Your session has expired.',
                    type: 'warning',
                    showClose: true,
                    duration: 5000,
                });
                trackError('Session expired', 'LP-ERR-FE-007', 'sessionWatch');
            }
        },
    },
});
</script>

